export const DAILY_FREE_PLAY_LIMIT = 3;
export const FREE_PLAY_TIME_ZONE = 'America/Los_Angeles';

export const getFreePlayDateKey = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: FREE_PLAY_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const values = Object.fromEntries(
    parts.filter((part) => part.type !== 'literal').map((part) => [part.type, part.value]),
  );
  return `${values.year}-${values.month}-${values.day}`;
};

export const getFreePlaysRemaining = (user, date = new Date()) => {
  const dailyFreePlay = user?.dailyFreePlay;
  const used = dailyFreePlay?.dateKey === getFreePlayDateKey(date) &&
    Number.isInteger(dailyFreePlay?.used)
    ? Math.max(dailyFreePlay.used, 0)
    : 0;
  return Math.max(DAILY_FREE_PLAY_LIMIT - used, 0);
};
